import { useQuery } from 'react-query';
import { fetcher, performanceReportingApiUrl } from 'data_sources/constants';
import type { ReportDataFieldRaw, ReportDataResponse } from '../_types';

export const getReportData = async (orgId: string, signal?: AbortSignal): Promise<ReportDataFieldRaw[]> => {
  const url = `${performanceReportingApiUrl()}/performance/reporting/v1/agency/${orgId}/fields`;
  const response = await fetcher({
    url,
    method: 'GET',
    options: { signal },
  });

  if (!response || typeof response !== 'object') {
    return [];
  }

  const parsed = response as ReportDataResponse;
  return Array.isArray(parsed.fields) ? parsed.fields : [];
};

export const useReportData = (orgId: string) => {
  return useQuery<ReportDataFieldRaw[]>(['reportData', orgId], ({ signal }) => getReportData(orgId, signal), {
    enabled: !!orgId,
  });
};
